function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "gearshaft-main-linear-gradient",
  x1: 22.77,
  y1: 138.42,
  x2: 22.77,
  y2: 183.79,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#303030"
}), React.createElement("stop", {
  offset: 0.26,
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 0.51,
  stopColor: "#595959"
}), React.createElement("stop", {
  offset: 0.67,
  stopColor: "#4d4d4d"
}), React.createElement("stop", {
  offset: 1
})), React.createElement("linearGradient", {
  id: "gearshaft-main-linear-gradient-2",
  x1: 55.4,
  y1: 134.1,
  x2: 55.4,
  y2: 188.03,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#303030"
}), React.createElement("stop", {
  offset: 0.12,
  stopColor: "#757575"
}), React.createElement("stop", {
  offset: 0.25,
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 0.37,
  stopColor: "#a6a6a6"
}), React.createElement("stop", {
  offset: 0.52,
  stopColor: "#c2c2c2"
}), React.createElement("stop", {
  offset: 0.67,
  stopColor: "#adadad"
}), React.createElement("stop", {
  offset: 0.84,
  stopColor: "#4d4d4d"
}), React.createElement("stop", {
  offset: 1
})), React.createElement("linearGradient", {
  id: "gearshaft-main-linear-gradient-3",
  x1: 49.01,
  y1: 81.85,
  x2: 61.8,
  y2: 81.85,
  xlinkHref: "#gearshaft-main-linear-gradient-2"
}), React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: 55.4,
  cy: 24.95,
  fx: 66.13989329043483,
  fy: 13.789143851383791,
  r: 24.95,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#329cfc"
})));

var SvgGearshaftMain = function SvgGearshaftMain(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "gearshaft-main",
    viewBox: "0 0 80.36 188.03",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    id: "assembly"
  }, React.createElement("path", {
    d: "M5.26,183.79H45.54V138.42H5.26S0,146.92,0,160.89,5.26,183.79,5.26,183.79Z",
    style: {
      fill: "url(#gearshaft-main-linear-gradient)"
    }
  }), React.createElement("rect", {
    x: 45.28,
    y: 134.1,
    width: 20.26,
    height: 53.93,
    rx: 3,
    style: {
      fill: "url(#gearshaft-main-linear-gradient-2)"
    }
  })), React.createElement("path", {
    id: "shaft",
    d: "M61.8,15.17H49.05v125a8.12,8.12,0,0,0,0,.86c0,4.15,2.86,7.52,6.39,7.52s6.39-3.37,6.39-7.52a7.56,7.56,0,0,0,0-.83h0Z",
    style: {
      fill: "url(#gearshaft-main-linear-gradient-3)"
    }
  }), React.createElement("circle", {
    id: "handle",
    cx: 55.4,
    cy: 24.95,
    r: 24.95,
    style: {
      fill: "url(#radial-gradient)"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGearshaftMain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gearshaft-main.1bd01eb6.svg";
export { ForwardRef as ReactComponent };